
export const checkPermission = (check) => {
    const permissions = JSON.parse(localStorage.getItem('permissions'));
    const role = localStorage.getItem('role');

    if (role === 'admin') {
        return true;
    }

    if (permissions && permissions.includes(check)) {
        return true;
    } else {
        return false;
    }
};